import { Fancybox } from "@fancyapps/ui";
import Aos from "aos";
import "./modules/Header";
import "./modules/Slider";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/About";

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;
window.Fancybox = Fancybox;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$(function () {
	setTimeout(() => {
		$(".loading-overlay").fadeOut(300);
	}, 1000);

	$(".news-item-small .news-item-title").matchHeight();

	let serviceList = $(".service-list");
	let originalImage = serviceList.data("bg");
	$(".service-item-overlay").each(function () {
		let image = $(this).data("image");
		$(this).hoverIntent(
			function () {
				serviceList.css("background-image", `url(${image})`);
			},
			function () {
				serviceList.css("background-image", `url(${originalImage})`);
			}
		);
		if ($(window).width() < 1024.08) {
			$(this).css("background-image", `url(${image})`);
		}
	});

	$(".about-nav a").click(function (e) {
		e.preventDefault();
		let href = $(this).attr("href");
		$("html, body").animate(
			{
				scrollTop: $(href).offset().top - $(".global-header").height(),
			},
			1000
		);
	});

	try {
		if ($(".about-nav").length > 0) {
			var spy = new Gumshoe(".about-nav a", {
				offset: function () {
					return $(".global-header").height();
				},
			});
		}
	} catch (error) {
		// console.log(error);
	}

	addFirstColumnClass();
	addRowNumberClasses();
	$(window).resize(function () {
		addFirstColumnClass();
		addRowNumberClasses();
	});

	$(".select-nav").change(function () {
		let href = $(this).val();
		let dataTarget = $(this).data("target");
		if (dataTarget === "blank") {
			window.open(href, "_blank");
		} else {
			window.location.href = href;
		}
	});

	if ($(".news-detail").length > 0) {
		$(document.body).addClass("has-bg");
	}

	Aos.init({
		duration: 1200,
		easing: "ease-out-back",
		delay: 100,
	});
});

function addFirstColumnClass() {
	const row = $(".row-computed");
	let currentTopPosition = null;

	row.find("> *")
		.removeClass("first-column")
		.each(function () {
			const itemTopPosition = $(this).position().top;

			if (
				currentTopPosition === null ||
				itemTopPosition > currentTopPosition
			) {
				currentTopPosition = itemTopPosition;
				$(this).addClass("first-column");
			}
		});
}

function addRowNumberClasses() {
	const rows = $(".row-computed");
	let rowCounter = 0;
	let lastTopPosition = null;

	// First pass: add row number classes and track last row position
	rows.each(function () {
		const columns = $(this).find("> *");
		let currentTopPosition = null;

		columns.each(function () {
			const itemTopPosition = $(this).position().top;

			// Check if we've moved to a new row
			if (
				currentTopPosition === null ||
				itemTopPosition > currentTopPosition
			) {
				currentTopPosition = itemTopPosition;
				rowCounter++;
			}

			$(this).addClass(`is-row-${rowCounter}`);
			// Update last known top position
			lastTopPosition = itemTopPosition;
		});
	});

	// Second pass: add row-last class to columns in the last row
	rows.each(function () {
		const columns = $(this).find("> *");

		columns.each(function () {
			if ($(this).position().top === lastTopPosition) {
				$(this).addClass("is-row-last");
			}
		});
	});
}
